import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useSelector } from "react-redux";

import Box from "@mui/material/Box";

import ContractsHeader from "../contract/ContractsHeader";
import MasterContractCover from "./MasterContractCover";

const LibraryMasterContracts = () => {
    const { filter } = useParams();
    const { templates } = useSelector((state) => state.contract);
    const [activeView, setActiveView] = useState("grid");
    const [templatesList, setTemplatesList] = useState(templates);
    // const { url } = useRouteMatch();

    const searchTemplates = (name) => {
        setTemplatesList(
            templates.filter((template) =>
                template.name.toLowerCase().includes(name.toLowerCase())
            )
        );
    };
    useEffect(() => {
        templates ? setTemplatesList(templates) : setTemplatesList([]);
    }, [templates]);
    useEffect(() => {
        if(filter === "all") {
            setTemplatesList(templates);
        } else {
            setTemplatesList(templates.filter((template) => template.type === filter.toUpperCase()));
        }
    }, [filter, templates]);

    return (
        <Box sx={{ flexBasis: "75%", pl: "1rem" }}>
            <ContractsHeader
                filterTemplates={searchTemplates}
                activeView={activeView}
                setActiveView={setActiveView}
            />
            <Box
                sx={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    columnGap: "1rem",
                    rowGap: "1rem",
                }}
            >
                <MasterContractCover templates={templatesList} />
            </Box>
        </Box>
    );
};
export default LibraryMasterContracts;
